import React from 'react';
import SuccessfulPage from './SuccessfulPage';

const SuccessfulPageConfig = {
	settings: {
		layout: {
			config: {
				navbar: {
					display: false,
				},
				toolbar: {
					display: false,
				},
				footer: {
					display: false,
				},
			},
		},
	},
	routes: [
		{
			path: '/success',
			element: (
				<React.Suspense fallback={<div>Loading...</div>}>
					<SuccessfulPage />
				</React.Suspense>
			),
		},
	],
};

export default SuccessfulPageConfig;
